import { AppEnvironment } from 'app/app-config/app-config.model';

/**
 * Used to configure the MediaAlpha API key for each environment.
 * You can find the implementation of API keys here: https://insurance-exchange.mediaalpha.com/help/code.html?;deyupIRyzMfWqQxckt36WEliBVJELCNANpqrtq0lPX6858DdqZ64Kl0PLOlYSAJFayy1pRMyfS-l8RFxP8Dh3o2sAQaq2g#ads-server-side-feed-integration.
 * Access the dashboard and any other information here: https://insurance-exchange.mediaalpha.com/#dashboard
 * Note that the API key and Placement Key are likely the same across all environments.
 * We only really care about the API URL - using the production URL in any capacity
 * could potentially harm our metrics. NEVER test the prod API URL in a lower environment.
 */
export const mediaAlphaAPIToken: ReadonlyMap<AppEnvironment, string> = new Map([
  ['local', 'cT0FvSO3bI5LqneJojWLOsC5xh1Up923'],
  ['development', 'cT0FvSO3bI5LqneJojWLOsC5xh1Up923'],
  ['staging', 'cT0FvSO3bI5LqneJojWLOsC5xh1Up923'],
  ['production', 'cT0FvSO3bI5LqneJojWLOsC5xh1Up923'],
]);

export const mediaAlphaPlacementKeyUWF: ReadonlyMap<AppEnvironment, string> = new Map([
  ['local', 'x586s2FQ2osV7nP8tngxGJE3achDkw'],
  ['development', 'x586s2FQ2osV7nP8tngxGJE3achDkw'],
  ['staging', 'x586s2FQ2osV7nP8tngxGJE3achDkw'],
  ['production', 'x586s2FQ2osV7nP8tngxGJE3achDkw'],
]);

export const mediaAlphaPlacementKeyOOM: ReadonlyMap<AppEnvironment, string> = new Map([
  ['local', 'GgLTFe-f3uItsGeHAerE2-OFT3qw8w'],
  ['development', 'GgLTFe-f3uItsGeHAerE2-OFT3qw8w'],
  ['staging', 'GgLTFe-f3uItsGeHAerE2-OFT3qw8w'],
  ['production', 'GgLTFe-f3uItsGeHAerE2-OFT3qw8w'],
]);

export const mediaAlphaAPIUrl: ReadonlyMap<AppEnvironment, string> = new Map([
  ['local', 'https://api.dev.quotefinders.net/api/v1/home-insurance/results'],
  ['development', 'https://api.dev.quotefinders.net/api/v1/home-insurance/results'],
  ['staging', 'https://api.stage.quotefinders.haus/api/v1/home-insurance/results'],
  ['production', 'https://api.prod.quotefinders.com/api/v1/home-insurance/results'],
]);
